__turbopack_context__.v({
  "listingMessage": "listing-message-module-scss-module__OB5h6q__listingMessage",
  "listingMessage_message": "listing-message-module-scss-module__OB5h6q__listingMessage_message",
  "listingMessage_sendMessage": "listing-message-module-scss-module__OB5h6q__listingMessage_sendMessage",
});
